import { de } from '@/i18n/de';
import { avatarColor } from '@/lib/avatar';
import { AppShell } from '@/components/AppShell';
import { Button } from '@/components/Button';

interface LocalHandoffScreenProps {
  name: string;
  /** 1-basierte Position in der Übergabereihenfolge. */
  position: number;
  total: number;
  onConfirm: () => void;
}

/**
 * Übergabeschritt zwischen zwei Spielern.
 *
 * Trennt die Karten voneinander: Der vorige Spieler sieht beim Weiterreichen
 * garantiert keine Rolle mehr, und der nächste deckt erst auf, wenn er das
 * Handy tatsächlich in der Hand hat.
 */
export function LocalHandoffScreen({ name, position, total, onConfirm }: LocalHandoffScreenProps) {
  return (
    <AppShell
      footer={
        <div className="mx-auto max-w-xl">
          <Button fullWidth onClick={onConfirm}>
            {de.local.handoffConfirm(name)}
          </Button>
        </div>
      }
    >
      <div className="flex h-full flex-col items-center justify-center gap-6 text-center">
        <p className="text-sm text-fg-muted">{de.local.handoffProgress(position, total)}</p>

        <div className="flex flex-col items-center gap-4">
          <p className="font-display text-sm font-semibold tracking-wide text-fg-muted">
            {de.local.handoffTitle}
          </p>
          <span
            className="flex h-24 w-24 items-center justify-center rounded-full font-display text-4xl font-bold text-black/80"
            style={{ background: avatarColor(name) }}
            aria-hidden="true"
          >
            {name.charAt(0).toUpperCase()}
          </span>
          <p className="font-display text-4xl font-extrabold break-words">{name}</p>
        </div>

        <p className="max-w-xs text-sm text-fg-muted">{de.local.handoffHint}</p>
      </div>
    </AppShell>
  );
}
